/**
 * [ File :: G_GridChild.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/lcCanvasGrid/dev/child/grid/G_GridChild.js
 * @목적 : 그리드기능을 추가하는 중간 클래스입니다.
 * @설명 : 그리드기능을 추가하는 중간 클래스입니다. 다중상속을 위한 처리가 되어 있습니다.
 * @진행 : 완료
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.27
 * @작성 : SuperMoon
 * @참조 :
 */

const G_GridChild = (function(superclass){

	return class extends superclass {

		constructor(obj) {
			super(obj);

			// [S] res 참조객체 - weight
			if(obj.res) obj.weight = this._checkRes(obj.weight, this.CODMOS._res[obj.res].weight, 0);
			this._weight = obj.weight;

			if (typeof obj.value !== 'undefined') {
				if (Array.isArray(obj.value)) {
					obj.value = Math.floor(Math.random() * (obj.value[1] + 1 - obj.value[0])) + obj.value[0]
					this._isRandom = true
				}
				this._value = obj.value;
			}

			// 오브젝트 값 읽기 블록 사용 시 value 가 set 될 타겟 변수
			if (typeof obj.variableTarget !== 'undefined') this._variableTarget = obj.variableTarget;

			// 해당 오브젝트를 밟았을 때 입는 대미지 크기
			if (typeof obj.damage !== 'undefined') this._damage = obj.damage;
			// 대미지가 적용 될 변수 id
			if (typeof obj.damageTarget !== 'undefined') this._damageTarget = obj.damageTarget;

			// [S] 논리속성 - target
			if(obj.target) this._target = obj.target;
		}
	}
});
export default G_GridChild;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/grid/G_GridChild.js